import script from "./SheetForeignFlipAsIs.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetForeignFlipAsIs.vue?vue&type=script&setup=true&lang=ts"

import "./SheetForeignFlipAsIs.vue?vue&type=style&index=0&id=2044f630&lang=css"

const __exports__ = script;

export default __exports__